/**
 * D2: Multi-Account State (load/save entire app state)
 * Source: src/accounts/logic/migration.ts
 * Note: Migration/normalization logic stays in migration.ts.
 *       dataLayer only handles the raw read/write.
 */

import { USE_BACKEND, STORAGE_KEY } from '../helpers';
import { safeStorageWrite } from '../../utils/storageQuota';
export async function loadMultiAccountState(): Promise<string | null> {
  if (USE_BACKEND) {
    throw new Error('Backend not implemented');
  }
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}
export async function saveMultiAccountState(serializedState: string): Promise<boolean> {
  if (USE_BACKEND) {
    throw new Error('Backend not implemented');
  }
  return safeStorageWrite(STORAGE_KEY, serializedState);
}